/** 核酸检测结果查询
 *  需要注意的是post方式入参data; get方式入参params
 *  @Author: chengyan
 */

import __request from '@/services/request'

/** POST请求: 获取健康卡列表
 *  @param { String } sign 签名信息
 *  @param { String } openId 用户openId
 */
export const queryCardList = (data = {}) => {
  return __request({
    method: 'post',
    url: '/Card/lists',
    data
  })
}

/** 获取登录用户-基本信息
 */
export const getUserInfo = (data = {}) => {
  return __request({
    method: 'get',
    url: '/Card/getUserInfo',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/health-card.js